import React from 'react';
import { Button, Card, Form, Input, Select, Switch, Tag } from 'antd';
import moment from 'moment';

export default function ProviderConfigCard(props) {
    const {
        title,
        providerKey,
        config,
        onChange,
        onSave,
        onTest,
        onDisconnect,
        saving,
        testing
    } = props;

    return (
        <Card title={title} extra={<Tag color={config.status === 'usable' ? 'green' : (config.status === 'unconfigured' ? 'default' : 'red')}>{config.status || 'unconfigured'}</Tag>}>
            <Form layout="vertical">
                <Form.Item label="Kích hoạt">
                    <Switch checked={!!config.enabled} onChange={(checked) => onChange(providerKey, 'enabled', checked)} />
                </Form.Item>

                {providerKey === 'viettel_post' ? (
                    <>
                        <Form.Item label="API base URL">
                            <Input value={config.api_base_url || ''} disabled />
                        </Form.Item>
                        <Form.Item label="Token trang cá nhân (seed token)">
                            <Input.Password value={config.seed_token || ''} onChange={(e) => onChange(providerKey, 'seed_token', e.target.value)} />
                        </Form.Item>
                        <div style={{ color: '#999', marginBottom: 12 }}>Base URL lấy từ cấu hình server.</div>
                        <Form.Item label="Access token chuẩn">
                            <Input value={config.access_token || ''} disabled />
                        </Form.Item>
                        <Form.Item label="Viettel User ID">
                            <Input value={config.viettel_user_id || ''} disabled />
                        </Form.Item>
                        <Form.Item label="Partner ID">
                            <Input value={config.viettel_partner_id || ''} disabled />
                        </Form.Item>
                        <Form.Item label="Số điện thoại tài khoản">
                            <Input value={config.viettel_phone || ''} disabled />
                        </Form.Item>
                        <Form.Item label="Hạn token">
                            <Input value={config.token_expired_at || ''} disabled />
                        </Form.Item>
                        <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 16, marginTop: 8, marginBottom: 12, fontWeight: 600 }}>
                            Địa chỉ lấy hàng bắt buộc
                        </div>
                        <Form.Item label="Tên người gửi">
                            <Input value={(config.sender_address && config.sender_address.name) || ''} onChange={(e) => props.onSenderAddressChange('name', e.target.value)} />
                        </Form.Item>
                        <Form.Item label="Số điện thoại lấy hàng">
                            <Input value={(config.sender_address && config.sender_address.phone) || ''} onChange={(e) => props.onSenderAddressChange('phone', e.target.value)} />
                        </Form.Item>
                        <Form.Item label="Địa chỉ chi tiết">
                            <Input value={(config.sender_address && config.sender_address.address_line) || ''} onChange={(e) => props.onSenderAddressChange('address_line', e.target.value)} />
                        </Form.Item>
                        <Form.Item label="Tỉnh / Thành phố">
                            <Select
                                showSearch
                                optionFilterProp="children"
                                value={config.sender_address && config.sender_address.province ? config.sender_address.province.id || undefined : undefined}
                                placeholder="Chọn Tỉnh / Thành phố"
                                onChange={props.onSenderProvinceChange}
                            >
                                {(props.provinces || []).map((item) => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Phường / Xã / Đặc khu">
                            <Select
                                showSearch
                                optionFilterProp="children"
                                disabled={!(config.sender_address && config.sender_address.province && config.sender_address.province.id)}
                                value={config.sender_address && config.sender_address.ward ? config.sender_address.ward.id || undefined : undefined}
                                placeholder="Chọn Phường / Xã / Đặc khu"
                                onChange={(value) => props.onSenderAddressChange('ward_id', value)}
                            >
                                {(props.wards || []).map((item) => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </>
                ) : (
                    <>
                        <Form.Item label="API base URL">
                            <Input value={config.api_base_url || ''} onChange={(e) => onChange(providerKey, 'api_base_url', e.target.value)} />
                        </Form.Item>
                        <Form.Item label="Token / API key">
                            <Input.Password value={config.token || ''} onChange={(e) => onChange(providerKey, 'token', e.target.value)} />
                        </Form.Item>
                        {'shop_id' in config ? (
                            <Form.Item label="Shop ID">
                                <Input value={config.shop_id || ''} onChange={(e) => onChange(providerKey, 'shop_id', e.target.value)} />
                            </Form.Item>
                        ) : null}
                    </>
                )}

                {'partner_id' in config && providerKey !== 'viettel_post' ? (
                    <Form.Item label="Partner ID">
                        <Input value={config.partner_id || ''} onChange={(e) => onChange(providerKey, 'partner_id', e.target.value)} />
                    </Form.Item>
                ) : null}

                <Form.Item label="Webhook secret">
                    <Input.Password value={config.webhook_secret || ''} onChange={(e) => onChange(providerKey, 'webhook_secret', e.target.value)} />
                </Form.Item>

                <div style={{ color: '#666', marginBottom: 12 }}>
                    {config.reason || 'Chưa test kết nối'}
                </div>
                <div style={{ color: '#999', marginBottom: 16 }}>
                    {config.tested_at ? `Test gần nhất: ${moment(config.tested_at).format('HH:mm DD-MM-YYYY')}` : 'Chưa test'}
                </div>
                <div className="d-flex" style={{ gap: 8, flexWrap: 'wrap' }}>
                    <Button onClick={() => onTest(providerKey)} loading={testing}>Test connection</Button>
                    <Button type="primary" onClick={() => onSave(providerKey)} loading={saving}>Lưu</Button>
                    <Button danger onClick={() => onDisconnect(providerKey)} disabled={saving || testing}>Gỡ kết nối</Button>
                </div>
            </Form>
        </Card>
    );
}
